// ** Reusable chrome for every authentication screen.
//
// Renders the warm canvas, the elevated card, the SalesPark logo, the
// emerald icon tile (signature), the uppercase eyebrow, the heading and
// the supporting copy - then drops the page's own form/content as
// children. Shared across /login, /otp-login, /forgot-password and
// /reset-password so the auth flow stays visually consistent.
//
// Styling lives in src/styles/auth.css (the `.sp-auth__*` contract).

import "src/styles/auth.css";
import VersionSmall from "src/@core/components/salespark/VersionSmall";

const AuthShell = ({ icon, eyebrow, title, subtitle, children }) => {
  return (
    <div className="sp-auth">
      <div className="sp-auth__card">
        <span className="sp-auth__glow" />
        <div className="sp-auth__card-body">
          <img className="sp-auth__logo" src="/images/logos/logo-horizontal.png" alt="SalesPark Academy" />

          <div className="sp-auth__header">
            {icon ? <span className="sp-auth__badge">{icon}</span> : null}
            <div className="sp-auth__heading">
              {eyebrow ? <span className="sp-auth__eyebrow">{eyebrow}</span> : null}
              {title ? <h1 className="sp-auth__title">{title}</h1> : null}
            </div>
          </div>

          {subtitle ? <p className="sp-auth__subtitle">{subtitle}</p> : null}

          {children}
        </div>
        <div className="sp-auth__footer">
          <VersionSmall />
        </div>
      </div>
    </div>
  );
};

export default AuthShell;
